<template>
  <div style="width: 100%">
    <div style="width: 100%;display: flex;justify-content: center;align-items: center;">
      <strong style="margin-right: 10px;">当前审批状态: </strong>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item, index) of approverList" :key="index">{{ item }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="detail_modal_btns_container">
      <el-button
        type="primary"
        v-if="
          (parentData.id > 0 &&
            parentData.form.creator_id === $store.state.userInfo.userId &&
            parentData.form.document_status === 0) ||
            parentData.id <= 0
        "
        style="min-width: 140px"
        size="normal"
        @click="handleClick('save')"
        >保存</el-button
      >

      <!-- 报价专用 -->
      <el-button
        type="primary"
        v-if="
          parentData.id > 0 &&
            parentData.form.creator_id === $store.state.userInfo.userId &&
            menuPath === 'QuotationApply' &&
            parentData.form.document_status === 0
        "
        style="min-width: 140px"
        size="normal"
        @click="handleClick('submit')"
      >
        提交
      </el-button>

      <el-button
        type="danger"
        v-if="
          parentData.id > 0 &&
            parentData.form.creator_id === $store.state.userInfo.userId &&
            parentData.form.document_status === 0
        "
        style="min-width: 140px"
        size="normal"
        @click="handleClick('del')"
        >删除</el-button
      >

      <el-button
        type="success"
        v-if="getApproveBtnVisible(parentData.form, menuPath, 'accept')"
        style="min-width: 140px"
        size="normal"
        @click="handleClick('accept')"
        >通过</el-button
      >

      <el-button
        type="danger"
        v-if="getApproveBtnVisible(parentData.form, menuPath, 'refuse')"
        style="min-width: 140px"
        size="normal"
        @click="handleClick('refuse')"
        >{{ refuseLabel }}</el-button
      >

      <el-button
        type="warning"
        v-if="getApproveBtnVisible(parentData.form, menuPath, 'revoke')"
        style="min-width: 140px"
        size="normal"
        @click="handleClick('revoke')"
        >撤销</el-button
      >

      <el-button
        v-show="parentData.form.id && ['Evection', 'Remittance', 'Sporadic'].includes(menuPath)"
        style="min-width: 140px"
        type="primary"
        size="normal"
        @click="
          () => {
            $emit('handleClick', 'printPreview')
          }
        "
        >打印预览</el-button
      >

      <!-- 只有能进明细的才会有这个按钮 -->
      <el-button
        v-show="parentData.form.id && ['QuotationApply'].includes(menuPath) && parentData.form.document_status === 9"
        style="min-width: 140px"
        type="primary"
        size="normal"
        @click="
          () => {
            $emit('handleClick', 'export')
          }
        "
      >
        导出
      </el-button>

      <!-- 邮寄菜单 - 单独保存快递单号按钮 -->
      <el-button
        v-show="
          parentData.form.id &&
            ['MailRecords', 'WorkReport'].includes(menuPath) &&
            parentData.form.document_status === 9 &&
            this.$store.state.userInfo.name === '连燕燕'
        "
        style="min-width: 140px"
        type="primary"
        size="normal"
        @click="
          () => {
            $emit('handleClick', 'saveExpressNo')
          }
        "
      >
        保存快递单号
      </el-button>

      <el-button
        style="min-width: 140px"
        size="normal"
        @click="
          () => {
            $emit('handleClick', 'close')
          }
        "
        >关闭</el-button
      >
    </div>
  </div>
</template>
<script>
import { getApprover, getApproveBtnVisible } from '@/utils/state'

export default {
  props: {
    parentData: {
      type: Object
    },
    menuPath: {
      type: String
    },
    refuseLabel: {
      type: String,
      default: '不通过'
    }
  },
  data() {
    return {}
  },
  methods: {
    getApproveBtnVisible,
    handleClick(code) {
      if (code === 'accept') {
        // 根据情况返回不同的code
        const emitCode = this.getApproveBtnVisible(this.parentData.form, this.menuPath, 'accept')

        if (emitCode === 'financial') {
          this.$emit('handleClick', 'financialReview')
        } else if (emitCode === 'manager') {
          this.$emit('handleClick', 'managerReview')
        } else if (emitCode === 'leader') {
          this.$emit('handleClick', 'leaderReview')
        }
      } else if (code === 'revoke') {
        this.$emit('handleClick', 'unReview')
      } else {
        this.$emit('handleClick', code)
      }
    }
  },
  computed: {
    // 获取审批人列表
    approverList() {
      return getApprover(this.parentData.form, this.menuPath)
        .split(', ')
        .reverse()
    }
  }
}
</script>
<style lang="less" scoped>
.detail_modal_btns_container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
</style>
